import * as React from 'react';

export default function Personal(props) {
  const {color, className} = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 31.059 29.503"
      {...props}
      className={className}
    >
      <defs>
        <clipPath id="a">
          <path data-name="Rectangle 50" fill={color} d="M0 0h31.059v29.503H0z" />
        </clipPath>
      </defs>
      <g data-name="Group 147">
        <g data-name="Group 74" clipPath="url(#a)" fill={color}>
          <path
            data-name="Path 3986"
            d="M6.369 8.465a.654.654 0 0 0 .279-.063 6.523 6.523 0 0 0 3.2-3.43A6.522 6.522 0 0 0 9.179.328a.654.654 0 0 0-.846-.265 6.519 6.519 0 0 0-3.2 3.43 6.519 6.519 0 0 0 .672 4.644.652.652 0 0 0 .567.328m.009-4.581a4.7 4.7 0 0 1 1.943-2.306 4.7 4.7 0 0 1 .28 3 4.692 4.692 0 0 1-1.943 2.305 4.693 4.693 0 0 1-.28-3"
          />
          <path
            data-name="Path 3987"
            d="M4.204 14.336a.653.653 0 0 0 .847-.264 6.519 6.519 0 0 0 .678-4.643 6.516 6.516 0 0 0-3.2-3.435.653.653 0 0 0-.847.264 6.521 6.521 0 0 0-.678 4.643 6.518 6.518 0 0 0 3.2 3.435M2.541 7.51a4.691 4.691 0 0 1 1.94 2.309 4.693 4.693 0 0 1-.285 3 4.67 4.67 0 0 1-1.94-2.31 4.7 4.7 0 0 1 .285-3"
          />
          <path
            data-name="Path 3988"
            d="M6.493 20.924a.654.654 0 0 0 .568-.68 6.523 6.523 0 0 0-1.945-4.27 6.522 6.522 0 0 0-4.547-1.156.654.654 0 0 0-.569.68 6.522 6.522 0 0 0 1.945 4.27 6.032 6.032 0 0 0 3.8 1.2 6.148 6.148 0 0 0 .745-.04m-3.706-2.162A4.7 4.7 0 0 1 1.4 16.088a4.694 4.694 0 0 1 2.881.889 4.7 4.7 0 0 1 1.387 2.678 4.7 4.7 0 0 1-2.882-.889"
          />
          <path
            data-name="Path 3989"
            d="M13.03 23.351a6.522 6.522 0 0 0-4.159-2.169 6.518 6.518 0 0 0-4.3 1.884.654.654 0 0 0-.031.886 6.524 6.524 0 0 0 4.16 2.172h.143a6.6 6.6 0 0 0 4.158-1.886.654.654 0 0 0 .03-.886m-4.283 1.463a4.694 4.694 0 0 1-2.74-1.259 4.644 4.644 0 0 1 2.818-1.074 4.693 4.693 0 0 1 2.74 1.259 4.689 4.689 0 0 1-2.819 1.069"
          />
          <path
            data-name="Path 3990"
            d="M24.411 8.4a.654.654 0 0 0 .846-.265 6.523 6.523 0 0 0 .671-4.644 6.523 6.523 0 0 0-3.2-3.431.654.654 0 0 0-.847.265 6.522 6.522 0 0 0-.671 4.644 6.523 6.523 0 0 0 3.2 3.43m-1.671-6.822a4.673 4.673 0 0 1 1.943 2.308 4.7 4.7 0 0 1-.281 3 4.672 4.672 0 0 1-1.943-2.307 4.7 4.7 0 0 1 .281-3"
          />
          <path
            data-name="Path 3991"
            d="M26.008 14.073a.654.654 0 0 0 .846.264 6.518 6.518 0 0 0 3.2-3.435 6.521 6.521 0 0 0-.678-4.643.654.654 0 0 0-.847-.264 6.518 6.518 0 0 0-3.2 3.435 6.519 6.519 0 0 0 .679 4.643m.569-4.254a4.7 4.7 0 0 1 1.94-2.309 4.691 4.691 0 0 1 .285 3 4.693 4.693 0 0 1-1.94 2.308 4.7 4.7 0 0 1-.285-3"
          />
          <path
            data-name="Path 3992"
            d="M30.489 14.818a6.528 6.528 0 0 0-4.548 1.156 6.523 6.523 0 0 0-1.945 4.27.654.654 0 0 0 .569.68 6.115 6.115 0 0 0 .745.04 6.032 6.032 0 0 0 3.8-1.2 6.522 6.522 0 0 0 1.945-4.27.654.654 0 0 0-.569-.68m-2.215 3.947a4.693 4.693 0 0 1-2.881.889 4.694 4.694 0 0 1 1.387-2.678 4.691 4.691 0 0 1 2.881-.889 4.7 4.7 0 0 1-1.387 2.678"
          />
          <path
            data-name="Path 3993"
            d="M22.188 21.182a6.522 6.522 0 0 0-4.159 2.172.654.654 0 0 0 .03.886 6.6 6.6 0 0 0 4.154 1.886h.143a6.522 6.522 0 0 0 4.159-2.172.654.654 0 0 0-.03-.886 6.57 6.57 0 0 0-4.3-1.884m.124 3.636a4.7 4.7 0 0 1-2.821-1.07 4.666 4.666 0 0 1 2.745-1.268 4.627 4.627 0 0 1 2.821 1.07 4.672 4.672 0 0 1-2.741 1.258"
          />
          <path
            data-name="Path 3995"
            d="M16.008 25.025c-.006-.006-.014-.008-.02-.014s-.008-.014-.014-.02a.647.647 0 0 0-.091-.055.784.784 0 0 0-.354-.115.654.654 0 0 0-.122.019.394.394 0 0 0-.232.1.6.6 0 0 0-.09.055c-.006.006-.008.014-.014.02s-.014.008-.02.014l-3.138 3.375a.654.654 0 0 0 .958.89l2.659-2.863 2.658 2.863a.654.654 0 0 0 .958-.89Z"
          />
        </g>
      </g>
    </svg>
  );
}
